module.exports = __webpack_public_path__ + "img/snow-2.8d3d018b.svg";